import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { mediaUrl } from 'kts-platform-frame/entry/configUtils';
import withRouter from 'src/routes/withRouter';
import { Form, Drawer, Input, Divider, Button } from 'antd';

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
}

/** 绑定全局数据 */
@withRouter
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
}))
export default class Head extends UIBasic<IProps, ModulesState> {
    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    submitHandler = () => {

    }
    render() {
        const noInfo = '暂无信息';
        const data = this.modulesState.detailsData;
        const imgUrl = data.appIcon ? mediaUrl() + data.appIcon : require('./img.default.svg');
        return (
            <Drawer
                title={'应用详情'}
                width={400}
                onClose={() => ModulesAction.drawerDetailsVisibleChange(false)}
                visible={this.modulesState.drawerDetailsVisible}
                bodyStyle={{ paddingBottom: 20, display: 'flex', flex: 1 }}
            >
                <div className={css.drawerDetail}>
                    <div className={`${css.appName} ${css.borderBottom}`}>
                        <img src={imgUrl} alt="" />
                        <div className={css.nameWarpper} >
                            <div className={css.titleWrapper}>
                                <p className={css.title}>{data.appName}</p>
                                {
                                    data.categoryName ?
                                        <div className={css.secondName}>
                                            {data.categoryName}
                                        </div> : ''
                                }
                            </div>
                            {/* 开发公司 */}
                            <div className={css.developer}>{data.appCompany ? data.appCompany : noInfo}</div>
                        </div>
                    </div>
                    <div className={`${css.appBrief} ${css.borderBottom}`}>
                        <h1>应用简介</h1>
                        <p>{data.appIntroduction ? data.appIntroduction : noInfo}</p>
                    </div>
                    <div className={`${css.appBrief} ${css.borderBottom}`}>
                        <h1>应用描述</h1>
                        <p>
                            {data.appDescription ? data.appDescription : noInfo}
                            {
                                data.appDocUrl ?
                                    <Button type="link" onClick={() => ModulesAction.understandMore(data.appDocUrl)}>
                                        了解更多
                                    </Button> : null
                            }
                        </p>
                    </div>
                    {
                        data.appType === 1 &&
                        <div>
                            <div>
                                <p className={css.infoDetailTitle}>操作人</p>
                                <p className={css.infoDetailValue}> <span>{this.modulesState.userInfo.nickName}</span></p>
                            </div>
                            <div>
                                <p className={css.infoDetailTitle}>appKey</p>
                                <p className={css.infoDetailValue}> <span>{data.appKey ? data.appKey : '暂无信息'}</span></p>
                                <p className={css.infoDetailTitle}>appSecret</p>
                                <p className={css.infoDetailValue}> <span>{data.appSecret ? data.appSecret : '暂无信息'}</span></p>
                            </div>
                            <Divider />
                            <div>
                                <p className={css.infoDetailTitle}>
                                    <h1>应用秘钥</h1>
                                    {data.appType === 1 && false && <a href="javascript:;" className={css.refresh} onClick={ModulesAction.reFresh}>刷新秘钥</a>}
                                </p>

                                <Divider />
                                <div className={css.infoDetailContent}>
                                    <div className={css.cont}>
                                        <p className={css.infoDetailTitle}>AK</p>
                                        <p className={css.infoDetailValue}>
                                            {data.appInstanceAK ? data.appInstanceAK : '暂无信息'}
                                            {data.appInstanceAK && <a  onClick={() => ModulesAction.copy('appInstanceAK')}>复制</a>}
                                        </p>

                                    </div>
                                    <div className={css.cont}>
                                        <p className={css.infoDetailTitle}>SK</p>
                                        <p className={css.infoDetailValue}>
                                            {data.appInstanceSK ? data.appInstanceSK : '暂无信息'}
                                            {data.appInstanceSK && <a  onClick={() => ModulesAction.copy('appInstanceSK')}>复制</a>}
                                        </p>

                                    </div>
                                </div>
                            </div>

                        </div>
                    }
                    <div style={{ float: 'right', marginTop: '10px' }}>
                        {
                            data.isActivated === 1 ?
                                <>
                                    <Button className={css.antdBtnGhost} style={{ marginRight: '20px' }} onClick={() => { ModulesAction.prohibit(data); }} >禁用</Button>                             
                                    {data.appType !== 1 &&  <Button className={css.antdBtnGhost} onClick={() => { ModulesAction.openDrawerSetPower(data); }} >设置权限</Button>}
                                    
                                </> :
                                <Button className={css.antdBtnGhost} style={{ marginRight: '20px' }} onClick={() => { ModulesAction.isActivate(data); }} >激活</Button>
                        }

                    </div>
                </div>
            </Drawer>
        );
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/AppStore/AppManage/UI.DrawerDetails.tsx